import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD,
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALINSTITUTIONID,
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALID,
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_ID,
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID,
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_FAILURE,
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_SUCCESS,

    ACTION_TRIALINSTITUTIONLABORATORY_SAVE,
    ACTION_TRIALINSTITUTIONLABORATORY_SAVE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORY_SAVE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORY_CREATE,
    ACTION_TRIALINSTITUTIONLABORATORY_CREATE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORY_CREATE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORY_DELETE,
    ACTION_TRIALINSTITUTIONLABORATORY_DELETE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORY_DELETE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE,
    ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORY_CLEAR,
    ACTION_TRIALINSTITUTIONLABORATORY_FILTER,

    TrialInstitutionLaboratoryAction,
} from '../actions/trialInstitutionLaboratory';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialInstitutionLaboratoryState {
    formData: Dtos.TrialInstitutionLaboratory | Dtos.TrialInstitutionLaboratory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    deleteState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialInstitutionLaboratory[];
    formLength: number;
}

const initialState: ITrialInstitutionLaboratoryState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    deleteState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: ITrialInstitutionLaboratoryState, _isLoading: boolean): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: ITrialInstitutionLaboratoryState,
    formData: Dtos.TrialInstitutionLaboratory | Dtos.TrialInstitutionLaboratory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function loadFailure(state: ITrialInstitutionLaboratoryState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function filter(state: ITrialInstitutionLaboratoryState, formFilter: IFormFilter): ITrialInstitutionLaboratoryState {

    const items: Dtos.TrialInstitutionLaboratory[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.laboratory?.name?.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: ITrialInstitutionLaboratoryState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function clear(state: ITrialInstitutionLaboratoryState, propertiesToClear?: string[]): ITrialInstitutionLaboratoryState {

    if (!propertiesToClear) {
        const newState: ITrialInstitutionLaboratoryState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialInstitutionLaboratoryState, _isSaving: boolean): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialInstitutionLaboratoryState,
    formData: Dtos.TrialInstitutionLaboratory | Dtos.TrialInstitutionLaboratory[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialInstitutionLaboratoryState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialInstitutionLaboratoryState, _isCreating: boolean): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialInstitutionLaboratoryState,
    formData: Dtos.TrialInstitutionLaboratory,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialInstitutionLaboratoryState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function deleting(state: ITrialInstitutionLaboratoryState, _isDeleting: boolean): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function deleteSuccess(
    state: ITrialInstitutionLaboratoryState,
): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function deleteFailure(state: ITrialInstitutionLaboratoryState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: ITrialInstitutionLaboratoryState, _isValidating: boolean): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ITrialInstitutionLaboratoryState,
    formData: Dtos.TrialInstitutionLaboratory,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ITrialInstitutionLaboratoryState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryState {
    const newState: ITrialInstitutionLaboratoryState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const TrialInstitutionLaboratoryReducer: Reducer<ITrialInstitutionLaboratoryState> = (state: ITrialInstitutionLaboratoryState = initialState, action: TrialInstitutionLaboratoryAction) => {
    switch (action.type) {
        case ACTION_TRIALINSTITUTIONLABORATORY_LOAD:
        case ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALINSTITUTIONID:
        case ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALID:
        case ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_ID:
        case ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID:
            return loading(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORY_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORY_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORY_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALINSTITUTIONLABORATORY_SAVE:
            return saving(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORY_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORY_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORY_CREATE:
            return creating(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORY_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALINSTITUTIONLABORATORY_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORY_DELETE:
            return deleting(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORY_DELETE_SUCCESS:
            return deleteSuccess(state);
        case ACTION_TRIALINSTITUTIONLABORATORY_DELETE_FAILURE:
            return deleteFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE:
            return validating(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORY_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default TrialInstitutionLaboratoryReducer;